<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('hrvDesc.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="desc-content">
            <div class="desc-box">
                <div class="desc-title">{{ $t('hrvDesc.title0') }}</div>
                <div class="desc-info last-desc">
                    {{ $t('hrvDesc.desc0') }}
                    <div class="score-li">{{ $t('hrvDesc.level0') }}</div>
                    <div class="score-li">{{ $t('hrvDesc.level1') }}</div>
                    <div class="score-li">{{ $t('hrvDesc.level2') }}</div>
                    <div class="score-li">{{ $t('hrvDesc.level3') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '05hrvDesc',
    data() {
        return {
            theme: 'light'
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        }
    },
}
</script>

<style scoped>
.score-li {
    margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/status/05hrvDesc.vue